import { render, staticRenderFns } from "./ApiTest.vue?vue&type=template&id=5ac74637&"
import script from "./ApiTest.vue?vue&type=script&lang=js&"
export * from "./ApiTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ac74637')) {
      api.createRecord('5ac74637', component.options)
    } else {
      api.reload('5ac74637', component.options)
    }
    module.hot.accept("./ApiTest.vue?vue&type=template&id=5ac74637&", function () {
      api.rerender('5ac74637', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/ApiTest.vue"
export default component.exports